import React, { useState, useRef } from 'react';
import './FullReviewDesignOptions.scss';
import star from '../Components/images/star.svg';

const OPTIONS = [
  { id: 1, name: 'Soft background tints', desc: 'Sections use very subtle background shades; minimal borders.' },
  { id: 2, name: 'Card elevation (shadow)', desc: 'No borders; soft box-shadows separate each block.' },
  { id: 3, name: 'Spacing + hairline dividers', desc: 'Generous spacing with thin divider lines between sections.' },
  { id: 4, name: 'Rounded cards (tint + border)', desc: 'Each section is a rounded card with light border and faint tint.' },
];

function MockRatingCard() {
  return (
    <div className="dr-option-rating">
      <div className="dr-option-rating-left">
        <div className="dr-option-rating-num">
          <span>3.7</span>
          <img src={star} alt="" className="dr-option-star" />
        </div>
        <p className="dr-option-verified">480 Verified Buyers</p>
      </div>
      <div className="dr-option-rating-right">
        {['Excellent', 'Very Good', 'Good', 'Not Bad', 'Bad'].map((label, i) => (
          <div key={i} className="dr-option-bar-row">
            <span className="dr-option-label">{label}</span>
            <div className="dr-option-bar"><div className="dr-option-fill" style={{ width: i === 2 ? '5%' : '75%' }} /></div>
            <span className="dr-option-count">{i === 2 ? '0' : '80'}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function MockCustomerPhotos() {
  return (
    <div className="dr-option-photos">
      <h3 className="dr-option-heading">CUSTOMER PHOTOS (36)</h3>
      <div className="dr-option-photos-grid">
        {Array.from({ length: 12 }, (_, i) => (
          <div key={i} className="dr-option-thumb">
            {i === 11 ? <span className="dr-option-more">+21 more</span> : null}
          </div>
        ))}
      </div>
    </div>
  );
}

function MockReviewCard() {
  return (
    <div className="dr-option-review-card">
      <div className="dr-option-review-header">
        <span className="dr-option-stars">★★★★★</span>
      </div>
      <p className="dr-option-review-text">good i would highly recommend</p>
      <div className="dr-option-review-thumbs">
        <div className="dr-option-thumb small" /><div className="dr-option-thumb small" /><div className="dr-option-thumb small" />
      </div>
      <p className="dr-option-review-meta">Myntra Customer</p>
    </div>
  );
}

function MockReviewsSection() {
  return (
    <div className="dr-option-reviews">
      <h3 className="dr-option-heading">CUSTOMER REVIEWS (6)</h3>
      <MockReviewCard />
    </div>
  );
}

function OptionBlock({ optionId, title, description, sectionRef }) {
  return (
    <section id={`option-${optionId}`} ref={sectionRef} className={`dr-option-block dr-option-${optionId}`}>
      <div className="dr-option-meta">
        <h2 className="dr-option-title">Option {optionId}: {title}</h2>
        <p className="dr-option-desc">{description}</p>
      </div>
      <div className="dr-option-preview">
        <MockRatingCard />
        <MockCustomerPhotos />
        <MockReviewsSection />
      </div>
    </section>
  );
}

export function FullReviewDesignOptions() {
  const [activeId, setActiveId] = useState(1);
  const refs = { 1: useRef(null), 2: useRef(null), 3: useRef(null), 4: useRef(null) };

  const goToOption = (id) => {
    setActiveId(id);
    refs[id].current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="full-review-design-options-page">
      <header className="dr-page-header">
        <h1>Full-review section segregation options</h1>
        <p>Choose a style to separate Rating summary, Customer Photos, and Customer Reviews. Each option uses static mock data.</p>
        <nav className="dr-option-nav">
          {OPTIONS.map((opt) => (
            <button
              key={opt.id}
              type="button"
              className={`dr-nav-btn ${activeId === opt.id ? 'active' : ''}`}
              onClick={() => goToOption(opt.id)}
            >
              Option {opt.id}
            </button>
          ))}
        </nav>
      </header>

      <div className="dr-options-list">
        {OPTIONS.map((opt) => (
          <OptionBlock
            key={opt.id}
            optionId={opt.id}
            title={opt.name}
            description={opt.desc}
            sectionRef={refs[opt.id]}
          />
        ))}
      </div>
    </div>
  );
}
